import * as React from "react";
import appHistory from "../../AppHistory";
import { DateTimeFormatter } from "../../Shared/Util/DateTimeFormatter";
import * as moment from 'moment';
import i18n from "../../i18n";

interface IUpdateListItem {
  update: Api.INotificationViewModel;
}

class UpdateListItem extends React.Component<IUpdateListItem> {
  constructor(props: IUpdateListItem) {
    super(props);

    this.handleRowClick = this.handleRowClick.bind(this);
  }

  public render() {
    const { dateCreated, lastUpdatedArtefactDate } = this.props.update;
    var alreadyUpdated = moment(lastUpdatedArtefactDate).isAfter(moment(dateCreated));

    return (
      <tr onClick={this.handleRowClick}>
        <td>{this.props.update.referenceId}</td>
        <td className='title-link'>{this.props.update.responseTitle}</td>
        <td className='category'>{this.props.update.responseCategory}</td>
        <td>{DateTimeFormatter.ToShortDate(this.props.update.lastUpdatedArtefactDate)}</td>
        <td>{this.props.update.dateCreated ? DateTimeFormatter.ToShortDate(this.props.update.dateCreated) : '-'}</td>
        <td>{alreadyUpdated ?
          <span data-tooltip-id="docUpdateDays-tooltip"
            data-tooltip-content={i18n.t("update.alreadyUpdated")}>
            {this.calculateDocUpdateDays()}*
          </span>
          : <>{this.calculateDocUpdateDays()}</>
        }        </td>
        <td>{this.props.update.documentId || '-'}</td>
      </tr>
    )
  }

  private calculateDocUpdateDays(): string {
    const { dateCreated, lastUpdatedArtefactDate } = this.props.update;

    // If dateCreated (source document update date) is missing, return "-"
    if (!dateCreated || !lastUpdatedArtefactDate) {
      return '-';
    }

    // Use actual current time for 24-hour period counting (not startOf day)
    const currentDate = moment.utc();
    const artefactUpdatedMoment = moment.utc(lastUpdatedArtefactDate);
    const docUpdatedMoment = moment.utc(dateCreated);

    // First check if the artefact was updated after the source document's last update
    // If so, display "-" (no update pending)

    // Check if the difference between artefact's last update and source document's last update
    // is less than 24 hours AND one of them is close to the current date
    const hoursDiff = Math.abs(artefactUpdatedMoment.diff(docUpdatedMoment, 'hours'));
    const hoursFromCurrentToDoc = Math.abs(currentDate.diff(docUpdatedMoment, 'hours'));
    const hoursFromCurrentToArtefact = Math.abs(currentDate.diff(artefactUpdatedMoment, 'hours'));

    if (hoursDiff < 24 && (hoursFromCurrentToArtefact < 24 || hoursFromCurrentToDoc < 24)) {
      return '0';
    }

    // If the artefact was updated before source document update
    // According to requirements, we should display the number of days between
    // the current date and the source document's last update date (dateCreated)
    // This represents how many days have passed since the document was updated
    const daysDifference = currentDate.diff(docUpdatedMoment, 'days');

    // Count starts at 1 once the 24-hour mark has passed
    return daysDifference > 0 ? daysDifference.toString() : '0';
  }

  private handleRowClick(e: any) {
    if (this.props.update.isExternalArtefact) {
      appHistory.push(`/manage/${this.props.update.responseId}?isExternal=true&updateNotification=true`);
    } else {
      appHistory.push(`/manage/${this.props.update.responseId}?documentId=${this.props.update.documentId}`);
    }
  }
}

export { UpdateListItem };
